import { useLocation } from 'react-router-dom';

import { PortalMenuItem } from '../PortalNavigation.interfaces';

const useCurrentLocation = () => {
  const { pathname } = useLocation();
  const isCurrentLocation = (item: PortalMenuItem) => pathname === item?.link?.href;
  const hasChildrenWithCurrentLocation = (items: PortalMenuItem[] = []) =>
    items.some(isCurrentLocation);
  return { isCurrentLocation, hasChildrenWithCurrentLocation };
};

export default useCurrentLocation;
